import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Users, TrendingUp, Award, CheckCircle2 } from 'lucide-react';
export function SocialProofSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const cards = [{
    icon: Users,
    number: '+1.000',
    text: 'Profesionales confían en el sistema'
  }, {
    icon: Star,
    number: '4.9/5',
    text: 'Valoración promedio'
  }, {
    icon: TrendingUp,
    number: '+200',
    text: 'Recursos clínicos y legales'
  }, {
    icon: Award,
    number: '#1',
    text: 'Sistema elegido en Argentina'
  }];
  const badges = ['Consultorio Privado', 'Centros de Salud', 'Clínicas de Rehabilitación', 'Atención Domiciliaria', 'Obras Sociales'];
  return <section className="bg-olive-dark py-12 md:py-16 px-4 border-t border-white/5" data-id="element-184">
      <div className="max-w-3xl mx-auto" data-id="element-185">
        {/* Header Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8" data-id="element-186">
          <div className="flex items-center justify-center gap-1.5 mb-4" data-id="element-187">
            <div className="flex gap-0.5" data-id="element-188">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-189" />)}
            </div>
            <span className="text-amber-400 font-bold text-base ml-1.5" data-id="element-190">
              4.9/5
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3 leading-tight" data-id="element-191">
            Elegido por más de 1.000 Terapeutas Ocupacionales en Argentina
          </h2>
          <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto" data-id="element-192">
            El sistema de documentación clínica más completo y profesional del
            mercado
          </p>
        </motion.div>

        {/* Stats Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-2 gap-3 md:gap-4 mb-8" data-id="element-193">
          {cards.map((card, index) => <motion.div key={index} variants={itemVariants} className="bg-white/5 border border-white/10 rounded-xl p-4 md:p-5 flex flex-col items-center text-center" data-id="element-194">
              <div className="w-9 h-9 rounded-full bg-golden/20 flex items-center justify-center mb-3" data-id="element-195">
                <card.icon className="w-4.5 h-4.5 text-golden" data-id="element-196" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-1 tracking-tight" data-id="element-197">
                {card.number}
              </h3>
              <p className="text-white/70 text-xs md:text-sm font-medium" data-id="element-198">
                {card.text}
              </p>
            </motion.div>)}
        </motion.div>

        {/* Bottom Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center" data-id="element-199">
          <p className="text-white/50 text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-200">
            Utilizado en todo tipo de consultorios
          </p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-201">
            {badges.map((badge, index) => <div key={index} className="flex items-center gap-1.5 text-white/90 text-xs md:text-sm font-medium" data-id="element-202">
                <CheckCircle2 className="w-4 h-4 text-golden flex-shrink-0" data-id="element-203" />
                <span data-id="element-204">{badge}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}